// extracted by mini-css-extract-plugin
export default {"container":"button_container__TsESc","disabled":"button_disabled__waibj","large":"button_large__CgIGx","revert":"button_revert__BASPH"};